import orgApi from '@api/orgApi';
import ItemList from '@components/itemList';
import OrgTile from '@components/orgTile';
import useAuth from '@hooks/useAuth';
import { useTranslator } from '@i18n';
import { IconBinaryTree } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/orgs/')({
  component: OrgsList,
});

function OrgsList() {
  const { hasClaim } = useAuth();
  const t = useTranslator();

  return (
    <ItemList
      domain="orgs"
      icon={<IconBinaryTree />}
      readonly={!hasClaim('orgs/write', 'any')}
      api={orgApi}
      backButton={{ to: '/profile' }}
      title={t('orgs.title')}
      renderItem={(org) => <OrgTile org={org} />}
      availableFilters={['createdOn']}
    />
  );
}
